/** Partner logos under `skills_up/public/` */
export const PARTNER_LOGO_CAEDEL = '/logo-CAEDEL-1.png'
export const PARTNER_LOGO_SVS = '/SVS.png'
export const PARTNER_LOGO_SUPEMIR = '/SMA.png'
export const PARTNER_LOGO_PM = '/PM.png'

export type PartnerBlock = {
  id: string
  name: string
  logo: string
  /** Visual scale to compensate for internal whitespace/padding in the source file. */
  scale: number
}

export const partnerBlocks: readonly PartnerBlock[] = [
  // Wide horizontal logo, good content density — no compensation needed
  { id: 'caedel', name: 'CAEDEL', logo: PARTNER_LOGO_CAEDEL, scale: 1.0 },
  // White logo on transparent canvas — scale up slightly
  { id: 'svs', name: 'SVS', logo: PARTNER_LOGO_SVS, scale: 1.3 },
  // Large canvas, actual content occupies ~30% of height — zoom past padding
  { id: 'supemir', name: 'Supemir', logo: PARTNER_LOGO_SUPEMIR, scale: 1.8 },
  // Square canvas, content in centre ~50% — zoom to fill
  { id: 'pm', name: 'Proximity Management', logo: PARTNER_LOGO_PM, scale: 1.6 },
] as const
